import { Component, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';
import { APP_VERSION } from '../../environments/version';
import { environment } from '../../environments/environment';
// services
import { StartupService } from '../services/startup.service';
import { SharedService } from '../shared/services/shared.service';
import { Router } from '@angular/router';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

// Third Party
import { NgSelectComponent } from '@ng-select/ng-select';
import { Observable, Subscription, timer } from 'rxjs'; // used for testing purposes
import { take } from 'rxjs/operators';
// import { Firearm, Form4473Transferee } from '../shared/models/general';
// import { ModalType } from '../shared/models/constants';
import { DistributorService } from '../shared/services/distributor.service';
import { EmailService } from '../services/email.service';
import { WebsocketService } from '../shared/services/websocket.service';
import { ChatbotService } from '../chatbot/chatbot.service';
import { InactivityService } from '../shared/services/inactivity.service';
import { SettingsModalComponent } from '../shared/modals/settings-modal/settings-modal.component';
import { DeveloperControlsComponent } from '../developer-controls/developer-controls.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import {
  getFeatureVisibility,
  parseFfleZCheckResponse,
} from '../shared/functions';
import { AccountingService } from '../accounting/services/accounting.service';
import { NetworkSyncService } from '../shared/services/network-sync.service';
import {
  absolutifyFflEzUrls,
  parseFflEzResult,
  parseFflFirstThreeLastFive,
} from '../shared/functions';
import { BoundBook, BoundBookEntry, Email } from '../shared/models/general';
import { EmailType } from '../shared/models/constants';
import { NgClass, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
// import { CSSISearchTypes } from '../shared/models/cssi';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  animations: [
    trigger('divState', [
      state('expand', style({ width: '200px' })),
      state('collapse', style({ width: '50px' })),
      transition('expand => collapse', animate(300)),
      transition('collapse => expand', animate(300)),
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('2000ms', style({ opacity: 1 })),
      ]),
    ]),
  ],
  standalone: true,
  imports: [CollapseModule, TooltipModule, NgClass, AsyncPipe, FormsModule, NgSelectModule],
})
export class SideNavComponent implements OnDestroy {
  @ViewChild('boundbookSelect') boundbookSelect: NgSelectComponent;
  subscriptions = new Subscription();
  admin_is_collapsed: boolean = true;
  admin_reporting_collapsed: boolean = true;
  acquisitions_is_collapsed: boolean = true;
  dispositions_is_collapsed: boolean = true;
  accounting_is_collapsed: boolean = true;
  help_is_collapsed: boolean = true;
  user_help_file_is_collapsed: boolean = true;
  admin_help_file_is_collapsed: boolean = true;
  developer_is_collapsed: boolean = true;
  developer_help_file_is_collapsed: boolean = true;
  accounting_lists_collapsed: boolean = true;
  accounting_reports_collapsed: boolean = true;
  Vendor_is_collapsed: boolean = true;

  // Context Menu State
  showBoundBookMenu = false;
  menuTop = 0;
  menuLeft = 0;
  contextMenuBook: any = null;

  unreadAlertsCount: number = 0;
  appVersion = APP_VERSION;
  isProduction = environment.production;

  state = 'expand';
  public getFeatureVisibility = getFeatureVisibility;
  constructor(
    public startupService: StartupService,
    public sharedService: SharedService,
    public accountingService: AccountingService,
    public distributorService: DistributorService,
    public emailService: EmailService,
    private router: Router,
    public websocketService: WebsocketService,
    private chatbotService: ChatbotService,
    public inactivityService: InactivityService,
    public networkSync: NetworkSyncService,
    private modalService: BsModalService,
  ) {
    this.subscriptions.add(
      this.sharedService.master_file_created$.subscribe((response) => {
        console.warn(response);
        this.sharedService.raiseSuccessToast('master file created');
      }),
    );
    this.subscriptions.add(
      this.sharedService.connection_status$.subscribe((status) => {
        this.serverConnected = status;
      }),
    );
    this.subscriptions.add(
      this.websocketService.unreadAlerts$.subscribe((alerts) => {
        this.unreadAlertsCount = alerts ? alerts.length : 0;
      }),
    );
  }

  serverConnected: boolean = true;

  ngOnInit(): void {
  }

  goToExternalLink(something: string) {}
  openImpersonateModal() {}
  removeImpersonation() {}
  
  isAdmin(): boolean {
    const role = this.sharedService.logged_in_user?.role;
    return role === 'Admin' || role === 'Developer';
  }

  isDeveloper(): boolean {
    return this.sharedService.logged_in_user?.role === 'Developer';
  }

  routeClicked(page: string) {
    this.router.navigate([page]);
  }
  expandSideNav() {
    this.state = 'expand';
  }
  collapseSideNav() {
    this.state = 'collapse';
  }

  onBellClicked() {
    this.sharedService.openInventoryAlertsModal();
  }
  collapseAllMenus() {
    this.admin_is_collapsed = true;
    this.acquisitions_is_collapsed = true;
    this.dispositions_is_collapsed = true;
    this.accounting_is_collapsed = true;
    this.help_is_collapsed = true;
    this.user_help_file_is_collapsed = true;
    this.admin_help_file_is_collapsed = true;
    this.developer_is_collapsed = true;
    this.developer_help_file_is_collapsed = true;
    this.accounting_lists_collapsed = true;
    this.accounting_reports_collapsed = true;
    this.Vendor_is_collapsed = true;
  }
  // Toggle methods for each section
  toggleAdmin() {
    if (!this.admin_is_collapsed) {
      // If already expanded, collapse it
      this.admin_is_collapsed = true;
    } else {
      // If collapsed, collapse all others and expand this
      this.collapseAllMenus();
      this.admin_is_collapsed = false;
      this.state = 'expand';
    }
  }

  formatTime(ms: number | null): string {
    if (ms === null || ms <= 0) return '00:00';
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  toggleAcquisitions() {
    if (!this.acquisitions_is_collapsed) {
      this.acquisitions_is_collapsed = true;
    } else {
      this.collapseAllMenus();
      this.acquisitions_is_collapsed = false;
      this.state = 'expand';
    }
  }

  toggleDispositions() {
    if (!this.dispositions_is_collapsed) {
      this.dispositions_is_collapsed = true;
    } else {
      this.collapseAllMenus();
      this.dispositions_is_collapsed = false;
      this.state = 'expand';
    }
  }

  toggleAccounting() {
    if (!this.accounting_is_collapsed) {
      this.accounting_is_collapsed = true;
    } else {
      this.collapseAllMenus();
      this.accounting_is_collapsed = false;
      this.state = 'expand';
    }
  }

  toggleHelp() {
    if (!this.help_is_collapsed) {
      this.help_is_collapsed = true;
    } else {
      this.collapseAllMenus();
      this.help_is_collapsed = false;
      this.state = 'expand';
    }
  }

  toggleVendor() {
    if (!this.Vendor_is_collapsed) {
      this.Vendor_is_collapsed = true;
    } else {
      this.collapseAllMenus();
      this.Vendor_is_collapsed = false;
      this.state = 'expand';
    }
  }

  toggleAccountingLists() {
    this.accounting_lists_collapsed = !this.accounting_lists_collapsed;
  }

  toggleAccountingReports() {
    this.accounting_reports_collapsed = !this.accounting_reports_collapsed;
  }

  openPdf() {
    const pdfUrl = 'assets/pdfs/4473_continuation_sheet_f_5300_9a.pdf'; // Replace with the actual path to your PDF file
    // window.open(pdfUrl, '_blank'); // new window
    window.location.href = pdfUrl; // current window
  }

  async test() {
    this.sharedService.changeRoute('calendar');
    // this.sharedService.changeRoute('ffl-lookup');  // if (!this.sharedService.loading) {
    // this.sharedService.openIdSelectionModal();
    //  this.sharedService.openUserCredentials('this', 'that');
    //   this.sharedService.openEditBoundBookAcquisition(this.sharedService.bound_book[0])
    //  this.sharedService.openEditBoundBookFirearm(this.sharedService.bound_book[0])
    // this.sharedService.openEnterIdModal(21);
    // this.sharedService.openSerialNumberModal(null, null, null)
    // this.sharedService.openFirearmInfoDash(this.sharedService.bound_book[0]);
    // this.sharedService.openMessageModal('test', false);
    // this.sharedService.openDuplicateTTSNSelectionModal('test');
    // this.sharedService.openInventoryOptionsModal();
    //  this.sharedService.openScanIdModal();

    // Trigger a mock inventory found message for testing the websocket bell notification
    // this.websocketService.sendMessage({
    //   type: 'INVENTORY_FOUND',
    //   data: {
    //     item_name: 'GLOCK 19 GEN 5',
    //     vendor: 'Lipsey\'s',
    //     price: 539.00
    //   }
    // });
    //   a_manufacture: 'Acme Arms',
    //   a_importer: 'Acme Import',
    //   a_model: 'Model X',
    //   a_caliber_gauge: '9mm',
    //   a_additional_markings: 'none',
    //   a_ffl: '9-82-001-01-7C-02611',
    //   a_received_from_name: 'Example Supplier',
    //   a_address: '100 Main St',
    //   a_address2: '',
    //   a_business_name: 'Example Supplier LLC',
    //   a_zip_code: '12345',
    //   a_state: 'TX',
    //   a_city: 'Austin',
    //   a_date_acquired: '2026-02-09',
    //   d_ffl: '9-82-001-01-7C-02611',
    //   d_disposed_to: 'Example Buyer',
    //   d_business_name: 'Example Buyer LLC',
    //   d_form4473_id: 'TEST-4473',
    //   d_first_name: 'Jane',
    //   d_middle_name: 'Q',
    //   d_last_name: 'Public',
    //   d_sr_name: '',
    //   d_address: '200 Market St',
    //   d_address2: '',
    //   d_zip_code: 78701,
    //   d_state: 'TX',
    //   d_city: 'Austin',
    //   d_date_disposed: '2026-02-09',
    // } as BoundBookEntry;

    // this.sharedService.openPackingSlipPrintModal([testItem]);
    // this.sharedService.changeRoute('ffl-lookup');
    // this.sharedService.searchFflByName('benelli').subscribe(response => {
    //   console.log(response);
    // })
    // this.sharedService.openTextModal('test');
    // const ffl_raw = parseFflFirstThreeLastFive('9-82-001-01-7C-02611');
    // this.sharedService.getFflEzCheck(ffl_raw.first, ffl_raw.secondThird, ffl_raw.lastFive).subscribe(response => {
    //   const result = parseFfleZCheckResponse(response);
    //   console.log(result);
    // })
    // const email = new Email();
    // email.to = 'brian@boomstickdefense.com';
    // email.subject = 'Request for Updated FFL';
    // email.body = 'We are requesting a updated copy of your FFL as our current copy has expired.<br>Thank you.';
    // const email_type = EmailType.ffl;
    // this.sharedService.openEmailModal(email_type, email);
    // const to = 'brian@boomstickdefense.com'
    // const subject = 'Request for Updated FFL'
    // const text = 'We are requesting a updated copy of your FFL as our current copy has expired.'
    // this.emailService.sendEmail({to, subject, text}).subscribe(response => {
    //   console.warn(response)
    // })
    //this.sharedService.migrateBoundBookAddCompanyId();
    // this.sharedService.getFflEzCheck('9','82','99999').subscribe(response => {
    //   const fixedHtml = absolutifyFflEzUrls(response);
    // console.warn(parseFflEzResult(fixedHtml));
    // })
    // this.sharedService.openCreateForm3310Modal();
    // const type = getProductServiceType('850002469417',this.accountingService)
    // console.warn(type)
    // this.sharedService.openStatusModal('loading', StatusModalIndicator.spinner)
    // this.sharedService.openMessageModal('hello');
    // this.routeClicked('transfer-reporting');
    //this.chatbotService.toggleChatbot(true);
    // const test_object = {}
    // this.websocketService.sendMessage('hello');
    // console.warn(this.sharedService.company_info);
    // const emailData = { to: 'brian@boomstickdefense.com', subject: 'email test', text: 'just a test', pdfPath:`C:\\Users\\brian\\Downloads\\invoice-20250505_4020112666.pdf` };
    // this.emailService.sendEmail(emailData).subscribe(
    //     response => {
    //       console.log('Email sent:', response);
    //       alert('Email sent successfully!');
    //     },
    //     error => {
    //       console.error('Error sending email:', error);
    //       alert('Failed to send email.');
    //     }
    //   );
    // Open calendar popup
    // this.modalService.show(EventModalComponent, {
    //   class: 'modal-lg modal-dialog-centered modal-dark',
    // });
  }

  openSettingsModal(): void {
    this.modalService.show(SettingsModalComponent, {
      class: 'modal-md modal-dialog-centered',
      ignoreBackdropClick: false,
      keyboard: true,
    });
  }

  openDeveloperControlsModal(): void {
    this.modalService.show(DeveloperControlsComponent, {
      class: 'modal-xl modal-dialog-centered',
      backdrop: 'static',
      keyboard: false,
    });
  }

  build() {
    this.sharedService.raiseInfoToast(
      'This function has not been implemented yet',
    );
  }

  logout() {
    // Same cleanup the inactivity sign-out runs — close any open modal so
    // the brief window before the hard reload doesn't leave a stale dialog
    // floating, and clear the user immediately so background polling stops.
    this.sharedService.signOutCleanup();

    this.startupService.logout().subscribe({
      complete: () => {
        localStorage.removeItem('remember_me_email');
        localStorage.removeItem('cached_user');
        window.location.href = '/login';
      },
      error: () => {
        // Clear local state and redirect even if the server call fails
        localStorage.removeItem('remember_me_email');
        localStorage.removeItem('cached_user');
        window.location.href = '/login';
      },
    });
  }
  enterKioskMode() {
    this.sharedService.kiosk_mode = !this.sharedService.kiosk_mode;
    this.sharedService.changeRoute('kiosk-mode');
  }
  boundbookChanged(event: any) {
    this.sharedService.updateSelectedBoundBook(event);
  }

  onBoundBookContextMenu(event: MouseEvent, book: any) {
    event.preventDefault();
    this.contextMenuBook = book;

    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    this.menuLeft = rect.right + 10;
    this.menuTop = rect.top;
    this.showBoundBookMenu = true;

    // Close menu on click anywhere
    const closeMenu = () => {
      this.showBoundBookMenu = false;
      document.removeEventListener('click', closeMenu);
    };
    setTimeout(() => {
      document.addEventListener('click', closeMenu);
    }, 100);
  }

  async setDefault(book: any) {
    if (book) {
      await this.sharedService.setDefaultBoundBook(book.boundbook_id);
      this.sharedService.updateSelectedBoundBook(book);
    }
    this.showBoundBookMenu = false;
  }

  async editName(book: any) {
    if (!book) return;
    this.showBoundBookMenu = false;
    this.sharedService.openEditBoundBookModal(book);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
export interface CompetitorPricing {
  offer_id: string;
  name: string;
  price: number;
  vendor: string;
  shipping: string;
  url: string;
  is_available: boolean;
}

// force reload
